import { gql } from '@apollo/client';
import { FileFragment } from 'graphql/File/fragments/FileFragment';
/**
 * @const ExportSaleItemOptionsMutation
 * @since 1.0.0
 */
export const ExportSaleItemOptionsMutation = gql `
  mutation ExportSaleItemOptionsMutation($input: ExportSaleItemOptionsInput!) {
    exportSaleItemOptions(input: $input) {
      ...FileFragment
    }
  }

  ${FileFragment}
`;
